module.exports = __webpack_public_path__ + "media/sub4-2.4fe3a71d.mp4";